import { Box, Text } from '@mantine/core';
import { useState } from 'react';

// A logo on the background it is meant for (white or dark), for the kit summary and the editor alike.
// A URL that no longer loads (moved on the site, hotlinking blocked) shows `failedText` instead.
const LogoOnBackground = ({ src, label, background, height, padding, imageHeight, failedText, ...boxProps }) => {
  // Tracked per URL, so a new upload is tried again.
  const [failedSrc, setFailedSrc] = useState();
  return (
    <Box
      {...boxProps}
      h={height}
      p={padding}
      style={{
        background,
        border: '1px solid var(--mantine-color-default-border)',
        borderRadius: 8,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {src && src !== failedSrc ? (
        <img
          src={src}
          alt={label}
          onError={() => setFailedSrc(src)}
          style={{ maxHeight: imageHeight, maxWidth: '100%', objectFit: 'contain' }}
        />
      ) : (
        <Text size="xs" c={background === '#FFFFFF' ? 'dimmed' : 'gray.5'}>
          {src ? failedText : 'No logo yet'}
        </Text>
      )}
    </Box>
  );
};

export default LogoOnBackground;
